import React from "react";
import { PanelMenu } from "primereact/panelmenu";
import { Sidebar } from "primereact/sidebar";
import { useRouterActions } from "react-resource-router";
import constants from "../../constants";
import { useSchoolStore } from "../../store/SchoolStore";
import { useResourcesStore } from "../../store/ResourcesStore";

const SideMenue = ({ toast, setVisible, isVisible }) => {

  const toastS = React.useRef(toast);
  const { push } = useRouterActions();
  const [, { onSelectPage }] = useResourcesStore();
  const [{ schoolRoles },] = useSchoolStore();

  const selectOption = (role, breadCrumb) => {
    onSelectPage(breadCrumb);
    setVisible(false);
    push({ pathname:constants.routes.users, state: { roleId: role, toast: toastS } } );
  }

  const items = [
    {
      label: "Users",
      icon: "pi pi-fw pi-users",
      items: schoolRoles.map((p) => 
        ({
          label: p.name,
          icon: "pi pi-fw pi-user-plus",
          command: () => { selectOption(p.id,
          [
            { label: "Users",  command: () => { }},
            { label: p.name, command: () => { push({ pathname:constants.routes.users, state: { roleId: p.id, toast: toastS } }) } }
          ])}
        }))
    },
    {
      label: "Settings",
      icon: "pi pi-fw pi-cog",
      items: [
        {
          label: "Session/Term",
          icon: "pi pi-fw pi-bars",
          command: () => { push(constants.routes.sessions) }
        },
        {
          label: "Faculty/Department",
          icon: "pi pi-fw pi-sitemap",
          command: () => { push(constants.routes.faculty) }
        },
        {
          label: "Level/Grade",
          icon: "pi pi-fw pi-sort-amount-up-alt",
          command: () => { push(constants.routes.levelGrade) }
        },
        {
          label: "Class",
          icon: "pi pi-fw pi-sort-alpha-up",
          command: () => { push(constants.routes.class) }
        },
        {
          label: "Roles",
          icon: "pi pi-fw pi-key",
          command: () => { push(constants.routes.role) }
        }

      ]
    }
  ];

  return (
    <Sidebar visible={isVisible} onHide={() => setVisible(false)}>
      <PanelMenu model={items} />
    </Sidebar>
  );
};

export default SideMenue;
